var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-button',{class:_vm.classes,attrs:{"data-testid":"invite-group-button"},on:{"click":_vm.openModal}},[_vm._v("\n  "+_vm._s(_vm.displayText)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }